import './thesweetside/style';
import FormStructure from './thesweetside/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js